/**
 * Copyright 2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { Col, Row } from "react-awesome-styled-grid";
import { Box, Button, FlexContainer, Text, theme } from "@nordcloud/gnui";

type Props = {
  helperText: string;
  isApplyDisabled: boolean;
  isClearDisabled: boolean;
  onApply: () => void;
  onClear: () => void;
};

export function FilterSidebarFooter({
  helperText,
  isApplyDisabled,
  isClearDisabled,
  onApply,
  onClear,
}: Props) {
  return (
    <Col>
      <Row>
        <Box spacing="spacing02" css={{ marginBottom: 0 }}>
          <Text
            size="sm"
            color="text04"
            css={{ marginBottom: theme.spacing.spacing03 }}
          >
            {helperText}
          </Text>
          <FlexContainer justifyContent="start" alignItems="center">
            <Button
              mr={theme.spacing.spacing04}
              severity="high"
              disabled={isApplyDisabled}
              onClick={onApply}
            >
              Apply
            </Button>
            <Button
              mr={theme.spacing.spacing04}
              severity="low"
              disabled={isClearDisabled}
              onClick={onClear}
            >
              Clear
            </Button>
          </FlexContainer>
        </Box>
      </Row>
    </Col>
  );
}
